import { render } from "./messageConfig.vue?vue&type=template&id=4c7834a8"
import script from "./messageConfig.vue?vue&type=script&lang=js"
export * from "./messageConfig.vue?vue&type=script&lang=js"

import exportComponent from "/jenkins/workspace/zh-center-resource-webui_prev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__